export default __webpack_public_path__ + "static/parallaxImage1-53b23b15abc76c7cd7a91d41a1ae355d.png";